
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import FullPageLoader from "components/common/FullPageLoader";
import { inviteVendorsSelector, fetchAppointmentsVendors, addInviteVendors, fetchInvitedVendors } from "slices/inviteVendorSlice";
import VendorsWithAppointments from "./VendorsWithAppointments";
import AppointedVendorsList from "./AppointedVendorsList";
import Swal from "sweetalert2";
import { fetchAppointmentView } from "slices/appointmentSlice";


const apiService = new Api();
function InviteVendorList({ itemId, appointmentData }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showInvitedList, setInvitedList] = useState(false);
    const fetchingList = async () => {
        setLoading(true)
        await dispatch(fetchAppointmentsVendors(itemId))
        await dispatch(fetchAppointmentView(itemId))
        setLoading(false)
    }
    React.useEffect(() => {
        fetchingList()
    }, [])


    const handleInvitedList = React.useCallback(() => {
        setInvitedList(true);
    }, [showInvitedList])

    useEffect(() => {
        if (showInvitedList) {
            const element = document.getElementById("vendors-with-appt");
            if (element) element.scrollIntoView({ behavior: "smooth" });
        }
    }, [showInvitedList])


    return (
        <>
            <InviteVendors height={'height-auto'} itemId={itemId} appointmentData={appointmentData} mainLoader={loading} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} />
            <AppointedVendorsList height={'height-auto'} itemId={itemId} handleInvitedList={handleInvitedList} invitedList={showInvitedList} fetchAppointment={fetchingList} />

            {loading && <FullPageLoader />}
        </>

    )
}

const InviteVendorItem = ({
    item, index, selectedItems, handleChange
}) => {
    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.id} checked={selectedItems?.includes(item?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            <td>
                {item?.name}
            </td>
            <td>
                {item?.email}
            </td>

        </tr>
    )
}

const InviteVendors = ({ mainLoader, handleInvitedList, invitedList, itemId, appointmentData, height }) => {
    const dispatch = useDispatch()
    const { allVendors, last_page: totalPages } = useSelector(inviteVendorsSelector);

    const navigate = useNavigate()
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);

    const handleAddInviteVendorPopUp = (item) => {
        // Not used currently but kept for structure
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const handleSubmitInviteVendors = React.useCallback(() => {
        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                dispatch(fetchInvitedVendors(itemId))
                dispatch(fetchAppointmentsVendors(itemId))
                dispatch(fetchAppointmentView(itemId))
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };
        new Swal({
            title: "Are you sure?",
            text: "You want to invite these vendors?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(addInviteVendors({ vendor_ids: selectedItems, }, itemId, submitCallback))
            }
        })
    }, [selectedItems, itemId])

    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(allVendors.map((v) => v.id.toString()))
    }, [selectedItems, selectAll, allVendors])



    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                <th className="col-5">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-5">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>

            </tr>
        )
    }, [selectedItems, allVendors])


    const renderTableContent = React.useCallback(() => {

        return (
            allVendors?.map((item, index) => {
                return <InviteVendorItem item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} />
            })
        )
    }, [allVendors, selectedItems]);


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    const renderFooter = React.useCallback(() => {
        return (
            <div className="row-primary">

                <button
                    onClick={handleSubmitInviteVendors}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{
                        marginRight: 20
                    }}
                >
                    Invite Vendors
                </button>
            </div>
        )
    }, [selectedItems, invitedList, handleInvitedList])
    return (
        <>
            <ListLayout
                heading={`Invite Vendor (${appointmentData?.appid})`}
                time={false}
                height={height}
                title="Vendors"
                addButtonDisabled={true}
                buttonTitle="Add InviteVendor"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={() => dispatch(fetchAppointmentsVendors(itemId))}
                selectedItems={selectedItems}
                refAddutton={refAddutton}
                showConfirmDialog={showConfirmDialog}
                renderFooter={renderFooter}
                hideRemoveButton={true}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                haveBackBtn={true}
                onBackButtonClick={
                    () => navigate(`/appointments/view/${appointmentData?.id}`)
                }
            >
            </ListLayout>
        </>
    )

}

export default InviteVendorList;
